import React from "react"
import Sprite from "../components/sprite"

const GithubRepo = ({ repo }) => {
  return (
    <a
      href={repo.url}
      className="md:my-4 md:mx-4 my-2 bg-white/10 border-white/20 border w-full md:w-2/5 px-2 py-6 rounded-xl hover:shadow-sm hover:bg-white/20"
    >
      <div className="mx-2">
        <div className="font-semibold text-blue-300 text-lg">
          <div className="float-left text-gray-300 fill-current pt-1">
            <Sprite icon="git_repo" width="24px" />
          </div>
          {repo.name}
        </div>
        <div className="font-thin text-gray-300 mt-1">
          {repo.description !== "" ? repo.description : repo.name}
        </div>
        <div className="grid grid-cols-5 mt-1">
          <div className="col-span-3">
            {repo.languages.nodes.map(item => {
              return (
                <span
                  key={`${item.name}_item`}
                  className="rounded-full text-white px-2 text-xs mr-1 py-0.5 border border-gray-400"
                  style={{ backgroundColor: item.color }}
                >
                  {item.name}
                </span>
              )
            })}
          </div>
          <div className="col-span-1 text-gray-300 fill-current text-xs mt-1">
            <div className="float-left">
              <Sprite icon="star" width="16px" />
            </div>
            {repo.stargazers.totalCount}
          </div>
          <div className="col-span-1 text-gray-300 fill-current text-xs mt-1">
            <div className="float-left">
              <Sprite icon="git_fork" width="16px" />
            </div>
            {repo.forks.totalCount}
          </div>
        </div>
      </div>
    </a>
  )
}

export default GithubRepo
